import React, { Component } from 'react';
import './ReviewApplicants.css';

import Paper from 'material-ui/Paper';

import TenantDocumentList from 'components/tenant_app/components/tenant_profile/TenantDocumentList';
import TenantCreditCheck from './TenantCreditCheck';

import { AccentColor } from 'helpers/AccentColorHelper';
import MaskedText from '../MaskedText';
import { formatSinNumber } from 'helpers/StringHelper';
import { formatMoney } from 'helpers/Formatter';
import { normalizeSsn } from 'helpers/Validator';

const nameHeader = {
  fontSize: '25px',
  marginBottom: 0,
};

const secondaryNameHeader = {
  marginTop: '15px',
  fontSize: '18px',
  marginBottom: 0,
};

let style = {
  sub_header: {
    marginTop: '5px',
    marginBottom: 0,
    color: '#6F6F6F',
  },
  text_box: {
    marginTop: '5px',
    marginBottom: 0,
    color: '#6F6F6F',
    textAlign: 'justify',
  },
  monthly_income_row: {
    padding: '0 5px',
    marginTop: '15px',
  },
  bio_row: {
    padding: '0 5px',
    marginTop: '15px',
  },
  documents_row: {
    padding: '0 20px',
    marginTop: '15px',
  },
  button_row: {
    marginTop: '20px',
    textAlign: 'center',
  },
};

const countries = {
  CANADA: 'Canada',
  USA: 'United States',
};

class TenantInfo extends Component {
  //sin is default in the variables, only ssn will be specified in variable names
  renderSinNumber() {
    let sinNumber = this.props.sinNumber || null;

    let header = 'SIN Number';
    const ssnHeader = 'SSN';

    let maskValue = 'xxx-xxx-xxx';
    const ssnMaskValue = 'xxx-xx-xxxx';

    if (!sinNumber) {
      return;
    }

    sinNumber = formatSinNumber(sinNumber);

    if (this.props.landlordCountry === countries.USA) {
      sinNumber = normalizeSsn(sinNumber);
      header = ssnHeader;
      maskValue = ssnMaskValue;
    }

    return (
      <div className="col-sm-5 col-xs-6">
        <h4 style={nameHeader}>{header}</h4>
        <MaskedText secretValue={sinNumber} maskValue={maskValue} />
      </div>
    );
  }

  render() {
    const waitingOnApplication = 'Application not completed';
    const fullName = this.props.applicantData.full_name || 'Name';
    const email = this.props.applicantData.email || waitingOnApplication;
    const phoneNumber = this.props.applicantData.phone_number || waitingOnApplication;
    const yearlyIncome = this.props.applicantData.yearly_income
      ? formatMoney(this.props.applicantData.yearly_income)
      : waitingOnApplication;
    const birthday = this.props.applicantData.birthday || waitingOnApplication;
    const bio = this.props.applicantData.bio || null;

    const avatarStyle = {
      height: '120px',
      width: '120px',
      float: 'right',
      border: '0px solid #e1e1e1',
      boxShadow: 'none',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      marginRight: '20px',
      backgroundPosition: '50% 0',
      backgroundImage: 'url(' + this.props.applicantData.avatar_url + ')',
    };

    style['save_button'] = {
      color: '#fff',
      backgroundColor: AccentColor(),
      marginRight: '15px',
    };

    return (
      <div>
        <div className="row" style={{ padding: '0 20px' }}>
          <Paper circle={true} style={avatarStyle} zDepth={1} />

          <div id="float-left">
            <h4 style={nameHeader}> {fullName} </h4>
            <h5 style={style.sub_header}> {email} </h5>
            <h5 style={style.sub_header}> {phoneNumber} </h5>
            <h4 style={secondaryNameHeader}> Applicant Type </h4>
            <h5 style={style.sub_header}> {this.props.applicantData.applicant_type} </h5>
          </div>
        </div>

        <div className="row" style={style.monthly_income_row}>
          <div className="col-sm-5 col-xs-6">
            <h4 style={nameHeader}> Yearly Income </h4>
            <h5 style={style.sub_header}> {yearlyIncome}</h5>
          </div>
          <div className="col-sm-5 col-xs-6">
            <h4 style={nameHeader}> Birthday </h4>
            <h5 style={style.sub_header}> {birthday}</h5>
          </div>
        </div>

        <div className="row" style={style.bio_row}>
          {this.renderSinNumber()}
          <div className="col-sm-5 col-xs-6">
            <h4 style={nameHeader}> Bio </h4>
            <h5 style={style.text_box}> {bio} </h5>
          </div>
        </div>

        <div className="row" style={style.documents_row}>
          <TenantDocumentList
            documents={this.props.applicantData.government_ids}
            deleteTenantDocument={this.props.deleteTenantDocument}
          />
        </div>

        {this._renderGetCreditCheck()}
      </div>
    );
  }

  _renderGetCreditCheck = () => {
    if (!this.props.applied) return;
    if (!this.props.applicantData.birthday && !this.props.applicantData.credit_check_url) return;
    if (!this.props.previousAddress) return;

    return (
      <div className="row" style={style.documents_row}>
        <TenantCreditCheck
          creditCheckIsAnalyzing={this.props.applicantData.credit_check_is_analyzing}
          creditCheck={this.props.applicantData.credit_check_url}
          leadId={this.props.leadId}
          showCreditReport={this.props.showCreditReport}
          getApplication={this.props.getApplication}
          applicationID={this.props.applicationID}
        />
      </div>
    );
  };
}

export default TenantInfo;
